import React from 'react';
import { LogOut, Building2, Users, Calendar, MessageCircle, FileText } from 'lucide-react';

const RESTRICTED_DOMAINS = ['project-a.com', 'a11.global', 'a11.com'];

const Sidebar = ({ currentPath, onNavigate, onLogout }) => {
    const userEmail = localStorage.getItem('email') || '';
    const userDomain = userEmail.split('@')[1] || '';
    const isRestricted = RESTRICTED_DOMAINS.includes(userDomain);

    const nav = (path, icon, label) => (
        <button
            className={`sidebar-link${currentPath === path ? ' active' : ''}`}
            onClick={() => onNavigate(path)}
        >
            {icon}
            {label}
        </button>
    );

    return (
        <aside className="sidebar">
            <div className="sidebar-brand">
                <img src="/favicon.ico" alt="ChefCoco" className="sidebar-brand-icon" style={{ objectFit: 'cover' }} />
                <div className="sidebar-brand-text">
                    <span className="sidebar-brand-name">ChefCoco</span>
                    <span className="sidebar-brand-sub">Client Portal</span>
                </div>
            </div>

            <nav className="sidebar-nav">
                <div className="sidebar-section">
                    <div className="sidebar-section-label">Overview</div>
                    {nav('/overview', <Building2 size={16} />, 'Company Overview')}
                </div>

                <div className="sidebar-section">
                    <div className="sidebar-section-label">Account</div>
                    {!isRestricted && nav('/users', <Users size={16} />, 'User Management')}
                    {nav('/calendar', <Calendar size={16} />, 'Delivery Calendar')}
                </div>

                <div className="sidebar-section">
                    <div className="sidebar-section-label">Finance</div>
                    {nav('/transactions', <FileText size={16} />, 'Invoices')}
                </div>

                <div className="sidebar-section">
                    <div className="sidebar-section-label">Help</div>
                    {nav('/support', <MessageCircle size={16} />, 'Customer Support')}
                </div>
            </nav>

            <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
                <button className="sidebar-link" onClick={onLogout} style={{ color: 'rgba(255,255,255,0.5)' }}>
                    <LogOut size={16} />
                    Logout
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;
